import Logo2 from "../../assets/navbar/logo.svg";
import React, { useState, useEffect, useRef } from "react";
import "../homepage/homepage.css";
import { useNavigate, useLocation } from "react-router";
import SubmitIcon from "../../assets/contactus/submit.svg";
import "./auth.css";
import { ApiHelper } from "../../utilFunctions/utilfunction";
import { useForm } from "react-hook-form";

export const TwoFactorAuthentication = () => {
    const rawUserId = localStorage.getItem("user_id");
  const userId = rawUserId ? JSON.parse(rawUserId) : null;
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const email = location.state?.email;
    const [banner, setBanner] = useState();
    console.log(userId, "UserIfse");
    const [flashMessage, setFlashMessage] = useState("");
    const [message, setMessage] = useState("");
    const [isError, setIsError] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        trigger,
    } = useForm();
    const [otp, setOtp] = useState(new Array(6).fill(""));

    const inputsRef = useRef([]);

    const handleChange = (element, index) => {
        const value = element.value.replace(/[^0-9]/g, ""); // only digits
        if (!value) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Focus next input
        if (index < 5 && value) {
            inputsRef.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (otp[index]) {
                const newOtp = [...otp];
                newOtp[index] = "";
                setOtp(newOtp);
            } else if (index > 0) {
                inputsRef.current[index - 1].focus();
            }
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text").slice(0, 6).split("");
        const newOtp = [...otp];
        pastedData.forEach((char, index) => {
            if (index < 6 && /^[0-9]$/.test(char)) {
                newOtp[index] = char;
            }
        });
        setOtp(newOtp);
        // Focus last filled input
        const nextIndex = pastedData.length >= 6 ? 5 : pastedData.length;
        inputsRef.current[nextIndex].focus();
    };
    const handleOTPSubmit = async () => {
        setLoading(true);
        const user_id = userId?.value;
        const enteredOtp = otp.join("");

        if (!user_id || enteredOtp.length !== 6) {
            setIsError(true);
            setMessage("Invalid OTP or missing user ID.");
            setFlashMessage(true);

            setTimeout(() => {
                setFlashMessage(false);
                setMessage("");
                setIsError(false);
            }, 5000);
            return;
        }

        const token = localStorage.getItem("access_token");
        const headers = {
            Authorization: `Bearer ${token}`,
        };

        const isEmailUpdate = !!email; // assume `email` is passed via state or prop

        const reqToSend = isEmailUpdate
            ? {
                new_email: email,
                otp: enteredOtp,
            }
            : {
                user_id,
                otp: enteredOtp,
            };

        const url = isEmailUpdate ? "/email/update/verify" : "/verify-otp";

        try {
            const response = await ApiHelper(url, reqToSend, "POST", isEmailUpdate ? headers : {});

            if (response?.status === true || response?.code === 200) {
                if (!isEmailUpdate) {

                    localStorage.setItem("access_token", response?.data?.access_token);
                }


                setTimeout(() => {

                    if (isEmailUpdate) {
                        navigate("/profile"); 
                    } else {
                        navigate("/introduction");
                    }
                }, 1000);
            } else {
                const errorMsg = response?.message || "Verification failed.";
                setIsError(true);
                setMessage(errorMsg);
                setFlashMessage(true);

                setOtp(new Array(6).fill(""));
                inputsRef.current[0]?.focus();

                setTimeout(() => {
                    setFlashMessage(false);
                    setMessage("");
                    setIsError(false);
                }, 2000);
            }
        } catch (err) {
            setIsError(true);
            setMessage("Something went wrong. Please try again.");
            setFlashMessage(true);

            setOtp(new Array(6).fill(""));
            inputsRef.current[0]?.focus();

            setTimeout(() => {
                setFlashMessage(false);
                setMessage("");
                setIsError(false);
            }, 10000);
        } finally {
            setLoading(false);

        }
    };

    const handleResendOTPClick = async () => {
        setLoading(true)
       

        if (!userId) {
            setIsError(true);
            setMessage("User ID not found. Please log in again.");
            setFlashMessage(true);
            setTimeout(() => {
                setFlashMessage(false);
                setMessage("");
                setIsError(false);
            }, 5000);
            return;
        }

        try {
            const body = { user_id: userId?.value };
            const response = await ApiHelper("/resend-otp", body, "POST");

            if (response?.code === 200 && response?.status === true) {
                setIsError(false);
                setMessage(response?.message || "OTP resent successfully.");
                setFlashMessage(true);
            } else {
                setIsError(true);
                setMessage(response?.message || "Failed to resend OTP.");
                setFlashMessage(true);
            }
        } catch (error) {
            setIsError(true);
            setMessage("An error occurred while resending OTP.");
            setFlashMessage(true);
        }

        setTimeout(() => {
            setFlashMessage(false);
            setMessage("");
            setIsError(false);
        }, 10000);
        setLoading(false)
    };

    const navigate = useNavigate();
    useEffect(async () => {
        let url = "/banner";
        let bannerdata = await ApiHelper(url);
        setBanner(bannerdata);
    }, []);
    return (
        <section className="mainhomepage ">
            <div className="wholepopup d-flex justify-content-center align-items-center w-100">
                <div className="container d-flex flex-column back_image_color flex-md-row align-items-center ps-lg-0 pe-lg-0 mb-5">
                    {banner && banner.data.length ? (
                        <div className="col-12 col-md-6">
                            {banner.data.map((value, index) => (
                                <img
                                    key={index}
                                    className="for_height mw-100 w-100"
                                    src={value ? value.image_path : ""}
                                    alt="image"
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="col-12 col-md-6"></div>
                    )}

                    <div className="col-12 col-md-6">
                        <div
                            className="rightside_content d-flex flex-column justify-content-center align-items-center position-relative"
                            style={{ background: "#f0f0f0" }}
                        >
                            <img
                                className="logo2_bottom"
                                // style={{ marginTop: "10px" }}
                                src={Logo2}
                                alt="logo"
                            />

                            <form className="form w-100 d-flex flex-column align-items-center">
                                <h2
                                    className="mb-4 text-center fw-bold responsive-heading"
                                >
                                    Account Verification
                                </h2>
                                <p
                                    className="text-center mb-4"
                                    style={{ fontFamily: "Times New Roman", fontSize: "18px" }}
                                >
                                    Please enter a 6 digit passcode we sent you on your registered
                                    email.
                                </p>
                                <div className="otp-inputs w-100 d-flex justify-content-center gap-2">
                                    {otp.map((value, index) => (
                                        <input
                                            key={index}
                                            type="text"
                                            maxLength="1"
                                            value={value}
                                            ref={(el) => (inputsRef.current[index] = el)}
                                            onChange={(e) => handleChange(e.target, index)} // ✅ Change handler
                                            onKeyDown={(e) => handleKeyDown(e, index)} // ✅ Backspace handler
                                            onPaste={handlePaste} // ✅ Optional: handle paste on any field
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                textAlign: "center",
                                                fontSize: "1.5rem",
                                                borderRadius: "8px",
                                            }}
                                        />
                                    ))}
                                </div>
                                <div className="w-100 d-flex justify-content-end mt-2 px-2">
                                    {/* <span style={{ fontFamily: 'Times New Roman', fontSize: '16px', paddingLeft: '43px' }}>
                                        Remaining time: <strong>0.10s</strong>
                                    </span> */}

                                    <span
                                        style={{
                                            fontFamily: "Times New Roman",
                                            fontSize: "16px",
                                            // paddingRight: "43px",
                                            marginBottom: "10px",
                                        }}
                                    >
                                        Don’t get the code?{" "}
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleResendOTPClick();
                                            }}
                                            style={{  cursor: "pointer" }}
                                        >
                                            Resend
                                        </a>
                                    </span>
                                </div>
                                { flashMessage && message && (
                  <div
                    className={`d-flex mt-1 align-items-center pt-2 pt-sm-0 ${
                      isError ? "text-danger" : "text-black"
                    }`}
                    style={{marginBlock:'5px'}}
                  >
                    {!isError && (
                      <img className="ps-ms pe-2" src={SubmitIcon} alt="" />
                    )}
                    <span className="fs-5">
                        {message}
                    </span>
                  </div>
                )}
                                {loading && (
                                    <div className="spinner-border text-light" style={{
                                        width: "1.5rem",
                                        height: "1.5rem",
                                        borderWidth: "0.2em",
                                        borderColor: "#ccc", // All borders
                                        borderTopColor: "#333", // Spinner color
                                    }} role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                )}
                                <div className="d-flex justify-content-between mt-3" style={{ gap: '2.5rem' }}>
                                    <button
                                        type="button"
                                        style={{
                                            width: "150px",
                                            fontSize: "18px",
                                            fontWeight: "bold",
                                            fontFamily: "Times New Roman",
                                            background: "transparent",
                                            border: "2px solid #000",
                                            borderRadius: "7px",
                                            color: "#000",
                                        }}
                                        disabled={loading}
                                        onClick={() => navigate(-1)} // or your cancel logic
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="auth-button"
                                        style={{
                                            width: "50%",
                                            minWidth: "100px",
                                            maxWidth: "150px",
                                            fontSize: "clamp(14px, 2vw, 18px)",
                                            fontWeight: "bold",
                                            fontFamily: "Times New Roman",
                                        }}
                                        disabled={loading}
                                        onClick={handleOTPSubmit} // 🔁 New handler
                                    >
                                        Verify
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
